import React, {useState} from 'react';
import {
    useQuery,
    Datagrid,
    TextField,
    Pagination,
    Loading, NumberField, ListContextProvider
} from 'react-admin';
import keyBy from 'lodash/keyBy';
import IconBuscar from '@material-ui/icons/Search';
import IconSeleccionar from '@material-ui/icons/Done';
import {makeStyles} from "@material-ui/core";
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import {TextField as TextFieldMUI} from '@material-ui/core';
import IconCancelar from '@material-ui/icons/Close';

export const AutoridadesBusquedaDatagrid = (props) => {
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(12);
    const [sort, setSort] = useState({field: 'id', order: 'ASC'});
    const [filter, setFilter] = useState('');
    const [busqueda, setBusqueda] = useState('');

    const useStyles = makeStyles({
        button: {},
    });
    const classes = useStyles();

    const {data, total, loading, error} = useQuery({
        type: 'getList',
        resource: 'Autoridades',
        payload: {
            pagination: {page, perPage},
            sort,
            filter: {q: filter, preAdjudica: props.preAdjudica, conformaAdjudica: props.conformaAdjudica},
        }
    });

    if (loading) {
        return <Loading/>
    }
    if (error) {
        return <p>ERROR: {error}</p>
    }

    /*Botón seleccionar registro*/
    const BtnConfirmar = ({record}) => (
        <IconButton style={{fontSize: 15, padding: 2}}
                    onClick={() => {
                        props.callbackAutoridades(record);
                        props.callbackCloseDrawer(false)
                    }}
        >

            <IconSeleccionar style={{fontSize: 20}}/>
        </IconButton>
    );

    /*Botón de búsqueda*/
    const BtnBuscar = ({event}) => (
        <Button
            onClick={() => {
                setFilter(busqueda);
            }}
        >
            <IconBuscar style={{fontSize: 20}}/> <h4>{' buscar'}</h4>
        </Button>
    );

    const BtnVolver = ({record}) => (
        <Button variant="contained" size={"small"} color="primary" onClick={() => {
            props.callbackCloseDrawer(false)
        }}
        >
            <IconCancelar/>
            Volver
        </Button>
    );


    return (
        <ListContextProvider value={{data, total, page, perPage, setPage, filter, setFilter, sort}}>
            <div style={{margin: '3em'}}>
                {!props.oc &&
                <>
                    <TextFieldMUI label="Buscar"
                                  onChange={(v) => setBusqueda(v.target.value)}
                                  defaultValue={filter}
                    />


                    <BtnBuscar/>
                </>
                }
                <Datagrid
                    data={keyBy(data, 'id')}
                    ids={data.map(({id}) => id)}
                    currentSort={sort}
                    setSort={(field, order) => setSort({field, order})}
                >
                    {!props.oc &&
                    <BtnConfirmar/>
                    }
                    <TextField label="Cod." source="autoridad_codigo"/>
                    <TextField label="Nombre" source="nombre_apellido"/>
                    <TextField label="Sector" source="adjudica_sector"/>
                    <TextField label="Tipo de Firma" source="firma_tipo"/>
                    <NumberField label="Importe pesos hasta" source="importe_hasta_pesos"
                                 style={{textAlign: 'right', margin: '1em'}}
                                 options={{minimumFractionDigits: 2}}/>
                    <TextField label="Pre-Adjudica" source="pre_adjudica"/>
                    <TextField label="Conforma-Adjudica" source="conforma_adjudica"/>

                </Datagrid>
                <Pagination
                    rowsPerPageOptions={[]}
                    page={page}
                    setPage={setPage}
                    perPage={perPage}
                    setPerPage={setPerPage}
                    total={total}
                />
                <BtnVolver/>
            </div>
        </ListContextProvider>
    )
};
export default AutoridadesBusquedaDatagrid;